import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorPalette } from "@solveindustrial/Utilities/variables";

export const loadingSpinner: RecursivePartial<{
    defaultProps?: LoadingSpinnerProps | undefined;
}> = {
    defaultProps: {
        color: colorPalette.primary?.main,
    },
};
